/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { QuestionControl } from "./QuestionControl";
import type { QuestionOption } from "./QuestionOption";

export interface Question {
  id: string;
  control: QuestionControl;
  text: string;
  required?: boolean;
  options?: QuestionOption[];
}
